import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop, { ScrollToHash } from "./components/ScrollToTop";
import CookieBanner from "./components/CookieBanner";
import ColorblindFilters from "./components/ColorblindFilters";
import HTAGLandingPage from "./pages/HTAGLandingPage";
import ParticuliersLandingPage from "./pages/ParticuliersLandingPage";
import AccompagnementService from "./pages/AccompagnementService";
import DesignWebService from "./pages/DesignWebService";
import DepannageService from "./pages/DepannageService";
import CoachingService from "./pages/CoachingService";
import AIAutomationService from "./pages/AIAutomationService";
import LegalNotice from "./pages/LegalNotice";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ScrollToHash />
      <ColorblindFilters />
      <CookieBanner />
      <Routes>
        <Route path="/" element={<HTAGLandingPage />} />
        <Route path="/particuliers" element={<ParticuliersLandingPage />} />
        <Route path="/services/accompagnement" element={<AccompagnementService />} />
        <Route path="/services/design-web" element={<DesignWebService />} />
        <Route path="/services/depannage" element={<DepannageService />} />
        <Route path="/services/coaching" element={<CoachingService />} />
        <Route path="/services/ia-automatisations" element={<AIAutomationService />} />
        <Route path="/legal-notice" element={<LegalNotice />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
